import { axios as request } from "../../request/http";

const interfaceUrl = {
    "api_wmsCodeAll": "/wms/base/queryWms", // 仓库列表
    "api_wmsChannelAll": "/wms/channel/queryChannelList", // 仓库渠道列表查询
    "api_wmsBaseChannelAll": "/wms/channel/baseChannel", // 渠道基础列表查询(Grade Group)
    "api_wmsBatchUpdateChannel": "/wms/channel/batchUpdateChannel", // 批量设置仓库渠道
    "api_wmsHistoryList": "/wms/history/queryList", // 仓库日志分页查询
    "api_wmsInvList": "/wms/inv/queryList", //服务商仓库商品查询
    "api_wmsInvDisable": "/wms/inv/disable", // 下架
    "api_wmsInvEnable": "/wms/inv/enable" // 上架
}

// initial state
const state = {
    wmsChannelAll: [],
    wmsBaseChannelAll: [],
    wmsHistoryList: {},
    wmsInvList: []
}

// getters
const getters = {
    getWmsChannelList: state => {
        return state.wmsChannelAll
    },
    getWmsBaseChannelList: state => {
        return state.wmsBaseChannelAll
    },
    getWmsHistoryList: state => {
        return state.wmsHistoryList
    },
    getWmsInvList: state => {
        return state.wmsInvList
    },
}

// actions
const actions = {
    getWmsChannelList: ({
        commit,
        state
    }, params) => {
        params = params || {};
        let option = {
            url: interfaceUrl.api_wmsChannelAll,
            method: "GET",
            params,
        };
        return request(option).then(res => res.data).then(res => {
            if (res.code == 200) {
                commit('WMA_CHANNEL_ALL', res.data || []);
            } else {
                commit('WMA_CHANNEL_ALL', []);
            }
        }).catch(err => {
            commit('WMA_CHANNEL_ALL', []);
        })
    },
    getWmsBaseChannelList: ({
        commit,
        state
    }, params) => {
        params = params || {};
        let option = {
            url: interfaceUrl.api_wmsBaseChannelAll,
            method: "GET",
            params,
        };
        return request(option).then(res => res.data).then(res => {
            if (res.code == 200) {
                commit('WMA_BASE_CHANNEL_ALL', res.data || []);
            } else {
                commit('WMA_BASE_CHANNEL_ALL', []);
            }
        }).catch(err => {
            commit('WMA_BASE_CHANNEL_ALL', []);
        })
    },
    wmsBatchUpdateChannel: ({
        commit,
        state
    }, params) => {
        params = params || {};
        let option = {
            url: interfaceUrl.api_wmsBatchUpdateChannel,
            method: "POST",
            data: params,
        };
        return request(option).then(res => res.data)
    },
    getWmsHistoryList: ({
        commit,
        state
    }, params) => {
        params = params || {};
        let option = {
            url: interfaceUrl.api_wmsHistoryList,
            method: "GET",
            params,
        };
        return request(option).then(res => res.data).then(res => {
            if (res.code == 200) {
                commit('WMA_HISTORY_LIST', res || {});
            } else {
                commit('WMA_HISTORY_LIST', {});
            }
        }).catch(err => {
            commit('WMA_HISTORY_LIST', {});
        })
    },
    getWmsInvList: ({
        commit,
        state
    }, params) => {
        params = params || {};
        let option = {
            url: interfaceUrl.api_wmsInvList,
            method: "GET",
            params,
        };
        return request(option).then(res => res.data).then(res => {
            if (res.code == 200) {
                commit('WMA_INV_LIST', res.data || []);
            } else {
                commit('WMA_INV_LIST', []);
            }
        }).catch(err => {
            commit('WMA_INV_LIST', []);
        })
    },
    wmsInvDisable: ({
        commit,
        state
    }, params) => {
        params = params || {};
        let option = {
            url: interfaceUrl.api_wmsInvDisable,
            method: "POST",
            data: params,
        };
        return request(option).then(res => res.data)
    },
    wmsInvEnable: ({
        commit,
        state
    }, params) => {
        params = params || {};
        let option = {
            url: interfaceUrl.api_wmsInvEnable,
            method: "POST",
            data: params,
        };
        return request(option).then(res => res.data)
    },
}


// mutations
const mutations = {
    WMA_CHANNEL_ALL: (state, pageData) => {
        state.wmsChannelAll = pageData;
    },
    WMA_BASE_CHANNEL_ALL: (state, pageData) => {
        state.wmsBaseChannelAll = pageData;
    },
    WMA_HISTORY_LIST: (state, pageData) => {
        state.wmsHistoryList = pageData;
    },
    WMA_INV_LIST: (state, pageData) => {
        state.wmsInvList = pageData;
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/warehouse.js